import { useEffect, useRef } from "react";
import { If } from "@mobi/ds"

import IdeaIcon from "images/icons/idea.svg"

import { SimulationForm } from "./components/Form"
import { SimulationOffer } from "./components/Offer"

import useSimulation from "./hooks"

import "./style.scss"

const Simulation = () => {
  const {
    isSimulationSubmitting,
    setIsSimulationSubmitting,
    simulationOffers
  } = useSimulation()

  const hasSimulationOffers = simulationOffers && simulationOffers.length > 0

  const resultTitleRef = useRef(null);

  useEffect(() => {
    if (hasSimulationOffers && !isSimulationSubmitting) {
      resultTitleRef.current.focus();
    }
  }, [hasSimulationOffers, isSimulationSubmitting]);

  const handleBlur = () => {
    resultTitleRef.current.removeAttribute("tabindex");
  };

  return (
    <div className="simulation">
      <div className="simulation__container">
        <div className="simulation__simulator">
          <h1 className="simulation__title">Esse é o nosso simulador</h1>
          <p className="simulation__subtitle">
            Preencha os campos e encontre a melhor condição de crédito para você
          </p>

          <SimulationForm
            isSimulationSubmitting={isSimulationSubmitting}
            setIsSimulationSubmitting={setIsSimulationSubmitting}
          />
        </div>

        <If
          condition={isSimulationSubmitting}
          renderIf={
            <div className="simulation__result simulation__result--skeletons" >
              <p aria-live="assertive" className="simulation__result-title">
                Carregando sua simulação
              </p>
              <div className="simulation__offers">
                <div className="simulation__offer--skeleton" />
                <div className="simulation__offer--skeleton" />
              </div>

              <div className="simulation__fixed-rate--skeleton" />
            </div>
          }
        />

        <If
          condition={hasSimulationOffers && !isSimulationSubmitting}
          renderIf={
            <div id="simulation-result" className="simulation__result">
              <h2 className="simulation__result-title"
                              tabIndex="-1"
                              ref={resultTitleRef}
                              onBlur={handleBlur}
                            >
                Resultado da simulação
              </h2>

              <ul
                className="simulation__offers"
                aria-label="selecione uma proposta"
              >
                {(simulationOffers || []).map((offer, index) => (
                  <SimulationOffer key={index} offer={offer} />
                ))}
              </ul>
              <div className="simulation__fixed-rate">
                <IdeaIcon alt="Ícone de lâmpada" aria-hidden />
                <p className="simulation__fixed-rate-text">
                  <strong>Taxa fixa sem acréscimos!</strong> No Itaú, você sabe
                  o quanto vai pagar do começo ao fim do seu contrato.
                </p>
              </div>
            </div>
          }
        />
      </div>
    </div>
  )
}

export default Simulation
